/** Turkish relative time label for message / notification timestamps. */
export function formatRelativeTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return '';
  const diffMs = Date.now() - ts;
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return 'şimdi';
  if (diffMin < 60) return `${diffMin} dk`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH} sa`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 7) return `${diffD} gün`;
  return new Date(ts).toLocaleDateString('tr-TR');
}
